import { render, staticRenderFns } from "./ColorModelSetting.vue?vue&type=template&id=7b008c1c&scoped=true"
import script from "./ColorModelSetting.vue?vue&type=script&lang=js"
export * from "./ColorModelSetting.vue?vue&type=script&lang=js"
import style0 from "./ColorModelSetting.vue?vue&type=style&index=0&id=7b008c1c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b008c1c",
  null
  
)

export default component.exports